import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import * as moment from "moment";
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { filter, map, mergeMap, tap } from "rxjs/operators";
import { Config } from '../../../config/config';
import { ConfigService } from "../../../config/config.service";
import { Client } from '../../shared/client/client';
import { ClientService } from '../../shared/client/client.service';
import { Order, Reclamation } from './order';


@Injectable({
  providedIn: 'root'
})
export class OrderService {

  subClient: Subscription

  private client: Client;
  currentOrder$: BehaviorSubject<Order>;

  /**
   *
   * @param http
   * @param configService
   * @param clientService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private clientService: ClientService
  ) {
    this.subClient = this.clientService.getCurrentClient().subscribe(res => {
      this.client = res;
    })
  }

  ngOnDestroy() {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }

  /**
   *
   * @param client
   * @returns {Observable<Object>}
   */
  getTrackingList(client: Client, sousComptes): Observable<any> {
    return this.configService.getConfig().pipe(
      mergeMap<Config, Observable<any>>(config => {
        return this.http.get<Array<Order>>(config.apiPoint + config.getClientDemandes.replace("{client}", client.id), { params: { sousComptes: sousComptes } }).pipe(
          map<Array<Order>, Array<Order>>(orders => {
            return orders.map(order => {
              return this.converteDates(order);
            })
          })
        );
      })
    )
  }

  private converteDates(order: Order): Order {
    order.date_demandeM = moment(order.date_demande);
    return order;
  }

  private converteDatesRecla(recla: Reclamation): Reclamation {
    recla.date_reclamationM = moment(recla.date_reclamation);
    return recla;
  }

  getDetailsDemande(id: string): Observable<Order> {
    return this.configService.getConfig().pipe(
      mergeMap<Config, Observable<any>>(config => {
        return this.http.get<Order>(config.apiPoint + config.getDemande.replace('{demande}', id)).pipe(
          map<Order, Order>(order => {
            return this.converteDates(order);
          })
        )
      })
    )
  }

  getDetailsReclamation(client: Client, id: string): Observable<Reclamation> {
    return this.configService.getConfig().pipe(
      mergeMap<Config, Observable<any>>(config => {
        return this.http.get<Reclamation>(config.apiPoint + config.getClientReclamation.replace("{client}", client.id).replace('{reclamation}', id)).pipe(
          map<Reclamation, Reclamation>(recla => {
            return this.converteDatesRecla(recla);
          })
        )
      })
    )
  }

  countOrderInProcess(client: Client): Observable<number> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<number>(config.apiPoint + config.getClientOrdersCount.replace("{client}", client.id));
      })
    );
  }

  export(order: Order): Observable<ArrayBuffer> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.getDemandeExport.replace("{demande}", order.numero), { responseType: 'arraybuffer' }).pipe(
          tap(res => {
            let blob = new Blob([res], { type: 'application/pdf' });
            const nav = (window.navigator as any);
            if (nav.msSaveOrOpenBlob) {
              let newUrl = nav.msSaveOrOpenBlob(blob, `export_${order.numdemande}.pdf`);
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', `export_${order.numdemande}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }))
      }));
  }
  exportOfCurrentDemandes(client: Client, utilisateur: string, date_debut_demande: moment.Moment, date_fin_demande: moment.Moment, statuts: string[]) {
    return this.exportDemandes(client, utilisateur, date_debut_demande, date_fin_demande, statuts);
  }

  private exportDemandes(client: Client, utilisateur: string, date_debut_demande: moment.Moment, date_fin_demande: moment.Moment, statuts: string[]) {
    let statutString = ""
    let count = 0
    statuts.forEach(statut => {
      count++
      if (count == statuts.length) {
        statutString += statut
      } else {
        statutString += statut + "|"
      }
    })
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        let date_debut_formatted = '';
        let date_fin_formatted = '';
        if (moment.isMoment(date_debut_demande)) {
          date_debut_formatted = date_debut_demande.format('Y-MM-DD');
        }
        if (moment.isMoment(date_fin_demande)) {
          date_fin_formatted = date_fin_demande.format('Y-MM-DD');
        }
        return this.http.get(config.apiPoint + config.exportClientOrders.replace('{client}', client.id),
          {
            params: {
              statuts: statutString,
              date_debut_demande: date_debut_formatted,
              date_fin_demande: date_fin_formatted,
              utilisateur: utilisateur
            },
            responseType: 'arraybuffer'
          }).pipe(
            tap(res => {
              let blob = new Blob([res], { type: 'application/vnd.ms-excel' });
              const nav = (window.navigator as any);
              if (nav.msSaveOrOpenBlob) {
                let newUrl = nav.msSaveOrOpenBlob(blob, `export_${filter}.xlsx`);
              } else {
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', `export_demandes.xlsx`);
                //link.setAttribute('download', `export_${filter}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }))
      }));
  }

  exportReclamation(recla: Reclamation): Observable<ArrayBuffer> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.getClientReclamationExport.replace('{reclamation}', recla.numero), { responseType: 'arraybuffer' }).pipe(
          tap(res => {
            let blob = new Blob([res], { type: 'application/pdf' });
            const nav = (window.navigator as any);
            if (nav.msSaveOrOpenBlob) {
              let newUrl = nav.msSaveOrOpenBlob(blob, `export_${recla.numrecla}.pdf`);
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.setAttribute('download', `export_${recla.numrecla}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }))
      }));
  }

  getReclamationPj(recla, filename: string, filemime: string) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(`${config.apiPoint}/clients/${this.client.id}/reclamations/${recla.numero}/download`,
          { params: { filename: encodeURIComponent(filename), filemime: filemime } })
      }));
  }

  getDemandePj(demande, filename: string, filemime: string) {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get(config.apiPoint + config.getDemandePJ.replace("{demande}", demande.numero),
          { params: { filename: encodeURIComponent(filename), filemime: filemime } })
      }));
  }
}
